import { motion } from "framer-motion";
import { useHub } from "../lib/hubContent";
import { AddItemButton, EditItemButton, EditSectionButton } from "./HubEditor";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";

export default function Poetry() {
  const hub = useHub();
  const c = hub.section("poetry_head");
  const poems = hub.collection("poems") || [];

  return (
    <section id="poetry" data-testid="poetry-section" className="relative bg-[#241423] text-[#F6EEFA] py-24 md:py-32 overflow-hidden">
      <span className="absolute -bottom-16 -left-6 font-display font-black text-[18rem] md:text-[26rem] leading-none text-white/[0.04] select-none pointer-events-none" aria-hidden="true">
        008
      </span>
      <EditSectionButton sectionKey="poetry_head" label="Edit copy" />

      <div className="relative max-w-6xl mx-auto px-5 md:px-8">
        <SectionHeading
          eyebrow={c.eyebrow}
          title={
            <>
              {c.title_a} <span className="italic text-fuchsia-400">{c.title_b}</span>
            </>
          }
          note={c.note}
          noteColor="text-en-yellow"
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-8 items-start">
          {poems.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1} className={i % 3 === 1 ? "md:mt-14" : i % 3 === 2 ? "md:mt-7" : ""}>
              <motion.article
                data-testid={`poem-card-${p.id}`}
                whileHover={{ y: -6, rotate: i % 2 ? 0.6 : -0.6 }}
                transition={{ type: "spring", stiffness: 220, damping: 18 }}
                className="relative rounded-2xl bg-white/[0.05] border border-white/10 p-8 md:p-9 backdrop-blur-sm"
              >
                <div className="absolute top-4 right-4">
                  <EditItemButton kind="poems" item={p} />
                </div>
                <p className="font-mono text-[9px] tracking-[0.3em] uppercase text-fuchsia-300/60 mb-4">mood — {p.mood}</p>
                <h3 className="font-display font-bold text-2xl md:text-[1.7rem] leading-tight mb-6">{p.title}</h3>
                <div className="relative">
                  <span className="absolute -left-1 -top-3 font-display font-black text-6xl text-fuchsia-400/25 select-none" aria-hidden="true">
                    {(p.body || " ").trim().charAt(0)}
                  </span>
                  <p className="relative font-display italic text-[15px] md:text-base leading-[1.9] text-white/80 whitespace-pre-line pl-6">
                    {p.body}
                  </p>
                </div>
                <div className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
                  <span className="font-hand text-xl text-fuchsia-300/70 rotate-[-1deg]">— nelle</span>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 flex flex-wrap items-center gap-6">
            <p className="font-hand text-2xl text-fuchsia-200/60 rotate-[-1deg]">{c.footer_note}</p>
            <AddItemButton kind="poems" label="Add a poem" className="text-fuchsia-200" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
